import { apiPost } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IGroup } from "./getGroupList";

// 그룹 생성 요청 인터페이스
export interface ICreateGroupRequest {
  name: string;
  status?: string;
  user_ids?: string[];
}

/**
 * 그룹 생성 API 함수
 * @param data 생성할 그룹 데이터
 * @returns API 응답
 */
export const apiCreateGroup = async (data: ICreateGroupRequest) => {
  const response = await apiPost<IGroup>("/groups", data);
  return response;
};

/**
 * 그룹 생성 React Query 훅
 * @returns 뮤테이션 객체
 */
export const useCreateGroup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: apiCreateGroup,
    onSuccess: () => {
      // 그룹 목록 데이터 갱신
      queryClient.invalidateQueries({ queryKey: QueryKeys.group.all });
      queryClient.invalidateQueries({ queryKey: QueryKeys.group.list() });
    },
  });
};

export default useCreateGroup;
